<script>
  import Input from './Input'
  import Search from './Search'

  export default {
    Input,
    Search
  }
</script>



// WEBPACK FOOTER //
// index.vue?8a3a1578